// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2qCQ4","left":"styles_left__2ZILV"};